export const RAPORMID_GET = 'RAPORMID_GET';
export const RAPORMIDDETAIL_GET = 'RAPORMIDDETAIL_GET';